import { render, staticRenderFns } from "./technician-tips.vue?vue&type=template&id=4b887fc0&scoped=true&"
import script from "./technician-tips.vue?vue&type=script&lang=ts&"
export * from "./technician-tips.vue?vue&type=script&lang=ts&"
import style0 from "./technician-tips.vue?vue&type=style&index=0&id=4b887fc0&prod&lang=scss&scoped=true&"
import style1 from "./technician-tips.vue?vue&type=style&index=1&id=4b887fc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b887fc0",
  null
  
)

export default component.exports